(() => {
  const keys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','gbraid','wbraid','fbclid','ttclid','msclkid'];
  function init(root) {
    if (!root || root.dataset.songReady) return;
    root.dataset.songReady = 'true';
    const lifetime = new AbortController();
    const query = new URL(location.href).searchParams;
    function attribute(anchor) {
      const href = anchor.getAttribute('href');
      if (!href || href.startsWith('#')) return;
      const url = new URL(href, location.origin);
      if (url.origin !== location.origin || !/^\/(products|collections|pages)\//.test(url.pathname)) return;
      for (const key of keys) {
        const values = query.getAll(key);
        if (values.length === 1 && values[0].length <= 500 && !/[\u0000-\u001f]/.test(values[0])) url.searchParams.set(key, values[0]);
      }
      anchor.setAttribute('href', url.pathname + url.search + url.hash);
    }
    root.querySelectorAll('a[href]').forEach(attribute);
    root.addEventListener('click', event => {
      const anchor = event.target.closest('a[href]');
      if (anchor && root.contains(anchor)) attribute(anchor);
    }, {capture:true,signal:lifetime.signal});
    const hero = root.querySelector('#hero-shop'), closing = root.querySelector('#closing-shop'), sticky = root.querySelector('aside');
    let heroPassed = false, closingVisible = false;
    const overlays = 'dialog[open],#shopify-pc__banner,[aria-modal="true"]';
    function update() {
      if (!sticky) return;
      const overlay = [...document.querySelectorAll(overlays)].some(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
      const typing = /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName || '');
      const hidden = !heroPassed || closingVisible || overlay || typing;
      if (sticky.hidden !== hidden) sticky.hidden = hidden;
    }
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.target === hero) heroPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        if (entry.target === closing) closingVisible = entry.isIntersecting;
      }
      update();
    });
    if (hero) observer.observe(hero);
    if (closing) observer.observe(closing);
    const mutations = new MutationObserver(update);
    mutations.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['open','hidden','aria-hidden','style']});
    document.addEventListener('focusin',update,{signal:lifetime.signal});
    document.addEventListener('focusout',update,{signal:lifetime.signal});
    const carousels = [];
    root.querySelectorAll('[data-carousel]').forEach(carousel => {
      const track = carousel.querySelector('[data-carousel-track]');
      const controls = carousel.querySelector('[data-carousel-controls]');
      const previous = carousel.querySelector('[data-carousel-prev]');
      const next = carousel.querySelector('[data-carousel-next]');
      const status = carousel.querySelector('[data-carousel-status]');
      if (!track || !controls || !previous || !next || !status) return;
      const items = [...track.children];
      const step = () => items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth;
      const updateRail = () => {
        const active = matchMedia('(max-width:700px)').matches;
        controls.hidden = !active;track.tabIndex = active ? 0 : -1;
        if(!active){track.scrollLeft=0;return;}
        const size = Math.max(step(),1);
        previous.disabled = track.scrollLeft < 3;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 3;
        const index = Math.min(items.length,Math.round(track.scrollLeft/size)+1);
        const text = items.length ? `${index} of ${items.length}` : '0 items';
        if (status.textContent !== text) status.textContent = text;
      };
      const move = (direction,edge) => {
        const size = Math.max(step(),1),count = Math.max(1,Math.floor((track.clientWidth+1)/size));
        track.scrollTo({left:edge==='start'?0:edge==='end'?track.scrollWidth:track.scrollLeft+direction*size*count,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
      };
      previous.addEventListener('click',()=>move(-1),{signal:lifetime.signal});
      next.addEventListener('click',()=>move(1),{signal:lifetime.signal});
      track.addEventListener('scroll',updateRail,{passive:true,signal:lifetime.signal});
      track.addEventListener('keydown',event=>{
        if(!matchMedia('(max-width:700px)').matches || event.target!==track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();move(event.key==='ArrowLeft'?-1:1,event.key==='Home'?'start':event.key==='End'?'end':undefined);
      },{signal:lifetime.signal});
      const resize = new ResizeObserver(updateRail);resize.observe(track);carousels.push(resize);
      controls.hidden = false;updateRail();
    });

    root.songCleanup = () => { lifetime.abort(); observer.disconnect(); mutations.disconnect(); carousels.forEach(o=>o.disconnect()); };
    update();
  }
  function scan(scope) {
    if (scope.matches?.('[data-story]')) init(scope);
    scope.querySelectorAll?.('[data-story]').forEach(init);
  }
  scan(document);
  document.addEventListener('shopify:section:load',event=>scan(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelector('[data-story]')?.songCleanup?.());
})();
